var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('overview-layout',{ref:"overview",attrs:{"tableCfg":_vm.tableCfg}},[_c('template',{slot:"ExtraOptions"},[_c('round-button',{attrs:{"tooltip":"Remove all","icon":"delete_forever"},on:{"click":_vm.deleteAll}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }